export default {
  review: [],
  reviewForm: [],
  user: [],
};
